import "./App.css";
import { Route, Routes } from "react-router-dom";
import { ConfigProvider } from "antd";
import Navigation from "./navigation";
import Login from "./admin/login/login";
import ProtectedRoute from "./navigation/ProtectedRoute";
import ThemeObj from "./theme";
import UserNavigation from "./user_navigation";
import ClientNavigation from "./clientNavigation";
import ReceptionistNavigation from "./ReceptionistNavigation";
import TelecallerNavigation from "./telecallerNavigation";
import AccountantNavigation from "./account _navigation";
import HRNavigation from "./hr_navigation";
import Internship from "./internship_website/internship/internship";
import Homepage from "./internship_website/homepage/homepage";
import Contact from "./internship_website/contactuspage/contactpage";
import Blog2 from "./internship_website/blogspage/blog2";
import Blog3 from "./internship_website/blogspage/blog3";
import Blog1 from "./internship_website/blogspage/blog1";
import Coursepage from "./internship_website/coursepage/coursepage";
import Blogpage from "./internship_website/blogspage/blogpage";
import AboutPage from "./internship_website/aboutpage/aboutPage";
import InternshipGraphics from "./internship_website/internship/graphics/graphic";
import InternshipCoding from "./internship_website/internship/coding/coding";
import Internshiponsite from "./internship_website/internship/onsite/onsite";

function App() {


  return (
    <ConfigProvider theme={ThemeObj}>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/courses" element={<Coursepage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/internship" element={<Internship />} />
        <Route path="/internshipgraphics" element={<InternshipGraphics />} />
        <Route path="/InternshipCoding" element={<InternshipCoding />} />
        <Route path="/Internshiponsite" element={<Internshiponsite />} />
        <Route path="/blog" element={<Blogpage />} />
        <Route path="/blog1" element={<Blog1 />} />
        <Route path="/blog2" element={<Blog2 />} />
        <Route path="/blog3" element={<Blog3 />} />

        <Route
          path="/Admin/*"
          element={
            <ProtectedRoute>
              <Navigation />
            </ProtectedRoute>
          }
        />
        <Route
          path="/HR/*"
          element={
            <ProtectedRoute>
              <HRNavigation />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Employee/*"
          element={
            <ProtectedRoute>
              <UserNavigation />
            </ProtectedRoute>
          }
        />
        <Route
          path="/receptionist/*"
          element={
            <ProtectedRoute>
              <ReceptionistNavigation />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Client/*"
          element={
            <ProtectedRoute>
              <ClientNavigation />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Telecaller/*"
          element={
            <ProtectedRoute>
              <TelecallerNavigation />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Accountant/*"
          element={
            <ProtectedRoute>
              <AccountantNavigation />
            </ProtectedRoute>
          }
        />
      </Routes>
    </ConfigProvider>
  );
}

export default App;
